// Packages
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import axios from "axios";
import {Cloudinary} from "@cloudinary/url-gen";

// Components
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { API_URL } from "./utils/consts";
import { AuthProvider, refreshToken } from "./context/authprovider";
import { CLOUD_NAME } from "./utils/consts";

export const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  function(config) {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken && config.headers) {
      config.headers["Authorization"] = accessToken;
    }
    return config
  },
  function (error) {
    return Promise.reject(error);
  }
)

export const cld = new Cloudinary({
  cloud: {
    cloudName: CLOUD_NAME
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AuthProvider>
    <Router>
      <App />
    </Router>
  </AuthProvider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
